import * as React from 'react';
import { Form, FormState, useFormApi } from "informed";
import { Folder } from '../../misc/api/ReportsApiTypes';
import LoadingWithMessage from "../../misc/components/LoadingWithMessage";
import { MultiSelect } from '../../forms/informedv2/MultiSelect';
import { Required } from '../../forms/validation/Required';

interface ReportsConfigRootFolderFormState {
    RootFolder: Folder;
}

interface ReportsConfigRootFolderProps {
    fetchFolders: () => void;
    handleSubmit: (rootFolderId: string) => void;
    options: Array<Folder>;
}

export const ReportsConfigRootFolderForm = ({ options, handleSubmit }) => {
    const formApi = useFormApi<ReportsConfigRootFolderFormState>();

    const onSubmit = async () => {
        formApi.validate();
        const state = formApi.getState();

        handleSubmit(state.values.RootFolder.Id);
    }

    return (
        <>
            <div className="row">
                <div className="form-group">
                    <div className="col-sm-4">
                        <label htmlFor="RootFolder" className="pull-right">Report Server Root Folder</label>
                    </div>
                    <div className="col-sm-8">
                        <div>Select the <b>Root</b> Folder to retrieve reports from</div>
                        <MultiSelect
                            id="RootFolder"
                            field="RootFolder"
                            labelKey="Name"
                            valueKey="Id"
                            multi={false}
                            options={options}
                            validate={Required}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="form-group">
                    <div className="col-sm-4">
                        <button className="btn btn-primary" type="submit" onClick={() => onSubmit()}>Link</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export const ReportsConfigRootFolder = ({ fetchFolders, handleSubmit, options }: ReportsConfigRootFolderProps) => {
    React.useEffect(() => {
        fetchFolders();
    }, []);

    if (options) {
        return (
            <Form noValidate>
                <ReportsConfigRootFolderForm options={options} handleSubmit={handleSubmit} />
            </Form>
        );
    } else {
        return <LoadingWithMessage message="Loading Report Server Folders..." />
    }
}
